export class ResponseFechas {

    constructor(
        public fechaDesde: Date ,
        public fechaHasta: Date
    ) { }
}
